export const normalizeClientRecord = (item = {}) => ({
  clientId: item.clientId ?? item.ClientId ?? null,
  companyName: item.companyName ?? item.CompanyName ?? "",
  mail: item.mail ?? item.Mail ?? "",
  telephone: item.telephone ?? item.Telephone ?? item.Phone ?? "",
  clientType: item.clientType ?? item.ClientType ?? "",
  address: item.address ?? item.Address ?? "",
});
